import type { SearchContext, TileImage, Variation } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-link/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { shouldShowShortTitle } from '@tilelist/domain/feature-visibility/TitleVisibility.ts';
import { getLayoutImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapLink } from '@tilelist/layouts/mapping/ProductLink.ts';
import { mapFashionTitle, mapShortTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';

/*                                      */
export type TileLayout = {
    /**
 *
 */
    readonly variation: Variation;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];

    readonly primaryImage: TileImage;

    readonly showMultipleSizes: boolean;
};

/*                                               */
export function createTileLayout(
    variation: Variation,
    showTopInfos: boolean,
    showMultipleSizes: boolean,
    searchContext?: SearchContext,
    showAvailability = true,
): TileLayout {
    const patchedVariation: Variation = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
        availability: showAvailability ? variation.availability : undefined,
        ottoUp: showAvailability ? variation.ottoUp : undefined,
    };
    const { images, primaryImage } = getLayoutImages(variation);
    return {
        variation: patchedVariation,
        title: shouldShowShortTitle(searchContext) ? mapShortTitle(variation) : mapFashionTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
        showMultipleSizes,
    };
}
